<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="general"
          title="Report Project KPI"
          text="List of Project Task Detail(s)"
        >
          <v-layout
            row
            wrap>
            <v-flex
              xs6
              sm4
              md3
            >
              <v-menu
                v-model="menuDatePicker"
                :nudge-right="40"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="computedSearchByStartDate"
                    class="pl-2 pr-2"
                    required
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  >
                    <template v-slot:label>
                      Start Date<v-icon style="vertical-align: middle">search</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="searchBy.startDate"
                  no-title
                  @input="menuDatePicker = false"/>
              </v-menu>
            </v-flex>
            <v-flex
              xs6
              sm4
              md3
            >
              <v-menu
                v-model="menuDatePicker2"
                :nudge-right="40"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="computedSearchByEndDate"
                    class="pl-2 pr-2"
                    required
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  >
                    <template v-slot:label>
                      End Date<v-icon style="vertical-align: middle">search</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="searchBy.endDate"
                  no-title
                  @input="menuDatePicker2 = false"/>
              </v-menu>
            </v-flex>
            <v-flex
                xs6
                sm4
                md3
            >
              <v-combobox
                  v-model="searchBy.isDone"
                  :items="['Yes','No']"
                  label="is Approved"
                  multiple
                  small-chips
              ></v-combobox>
            </v-flex>
          </v-layout>
          <v-btn
              color="general"
              dark
              class="mb-2 ml-1 mr-1"
              @click="$refs.downloadExcel.generate()"
          >
            <download-excel
                ref="downloadExcel"
                :fetch="fetchData"
                :fields="excelFields"
                :before-generate="showProgressBar"
                :before-finish="hideProgressBar"
                class="btn btn-default"
                worksheet="worksheet"
                name="Report-ProjectTaskDetail.xls">
              <v-icon>mdi-file-excel</v-icon>&nbsp;
            </download-excel>Export By Filter
          </v-btn>
          <v-progress-linear
              v-show="loadingBar"
              :indeterminate="true"/>
<!--            :pagination.sync="pagination"-->
<!--            :total-items="totalRows"-->
          <v-data-table
            :headers="headers"
            :items="DataList"
            :rows-per-page-items="rowsAmount"
            dense
            expand
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr>
                <td>{{ props.item.taskObj.assignedTo.username }} ({{ props.item.taskObj.assignedTo.employee.firstName }})</td>
                <td>{{ props.item.project.customer.company.name }}</td>
                <td>{{ props.item.taskObj.desc }}</td>
                <td>{{ props.item.project.name }}</td>
                <td>{{ props.item.project.refNo }}</td>
<!--                <td>{{ getDifferenceInDays(new Date(), new Date(props.item.taskObj.endDate)) }} days</td>-->
                <td>{{ props.item.deviasi }} days</td>
                <td>{{ props.item.taskObj.startDate }}</td>
                <td>{{ props.item.taskObj.endDate }}</td>
                <td>{{ props.item.taskObj.isDone ? 'Yes' : 'No' }}</td>
                <td>{{ toStringDateOnly(props.item.taskObj.approveDateTime) }}</td>
              </tr>
            </template>
          </v-data-table>

        </material-card>
      </v-flex>

    </v-layout>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-icon
        size="16"
        @click="snack = false"
      >
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-container>
</template>
<script>
  import displayFormatterMixins from './../../../mixins/displayFormatterMixins'
  import axios from 'axios'

  export default {
    name: 'Project',
    mixins: [displayFormatterMixins],
    data: () => ({
      projectPhase: [
        'PREPARATION_COMPONENT', 'ASSEMBLY_PANEL', 'SETTING_AND_PROGRAMMING',
        'FACTORY_AUTOMATION_TEST', 'SHIPMENT_MACHINE', 'INSTALLATION', 'TRIAL',
        'COMMISSIONING'
      ],
      progressCalcList: [
        0, 12.5, 25, 37.5, 50, 62.5, 75, 87.5, 100
      ],
      menu: false,
      mixins: [displayFormatterMixins],
      snack: false,
      snackText: '',
      loadingBar: false,
      snackColor: '',
      dialog: false,
      valid1: false,
      lazyValidation1: false,
      menuDatePicker: false,
      menuDatePicker2: false,
      search: '',
      searchBy: {
        startDate: '',
        endDate: '',
        isDone: ['Yes','No'],
      },
      companies: [],
      customers: [],
      pagination: {},
      DataList: [],
      userLoginMap: Map,
      totalRows: 0,
      rowsAmount: [5, 20, 50, 100],
      loading: true,
      headers: [
        { text: 'Username', value: 'taskObj.assignedTo.username' },
        { text: 'Company', value: 'project.customer.company.name' },
        { text: 'Task Desc', value: 'taskObj.desc' },
        { text: 'Pro. Name', value: 'project.name' },
        { text: 'Pro. Ref', value: 'project.refNo' },
        { text: 'Deviasi', value: 'deviasi' },
        { text: 'Start Date', value: 'taskObj.startDate' },
        { text: 'End  Date', value: 'taskObj.endDate' },
        { text: 'Approved', value: 'taskObj.isDone' },
        { text: 'Apprv. Date', value: 'taskObj.approveDateTime'}
      ],
      excelFields: {
        'Username': {
          callback: (value) => {
            let output = `${value.taskObj.assignedTo.username} (${value.taskObj.assignedTo.employee.firstName})`
            return output
          }
        },
        'Company': 'project.customer.company.name',
        'Task Desc': 'taskObj.desc',
        'Pro. Name': 'project.name',
        'Pro. Ref': 'project.refNo',
        'Deviasi': {
          callback: (value) => {
            const diffInMs = Math.abs(new Date() - new Date(value.taskObj.endDate))
            let output = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
            return output
          }
        },
        'Start Date': {
          callback: (value) => {
            if (value.taskObj.startDate) {
              return new Date(value.taskObj.startDate).toLocaleDateString('en-GB')
            } else {
              return ''
            }
          }
        },
        'End Date': {
          callback: (value) => {
            if (value.taskObj.endDate) {
              return new Date(value.taskObj.endDate).toLocaleDateString('en-GB')
            } else {
              return ''
            }
          }
        },
        'Approved': {
          callback: (value) => {
            return value.taskObj.isDone ? 'Yes' : 'No'
          }
        },
        'Apprv. Date': {
          callback: (value) => {
            if (value.taskObj.approveDateTime) {
              return new Date(value.taskObj.approveDateTime).toLocaleDateString('en-GB')
            } else {
              return ''
            }
          }
        },
      },

    }),

    computed: {
      computedSearchByStartDate () {
        return this.formatDate(this.searchBy.startDate)
      },
      computedSearchByEndDate () {
        return this.formatDate(this.searchBy.endDate)
      }
    },
    watch: {
      searchBy: {
        async handler () {
          this.debouncedGetData()
        },
        deep: true
      },
      // pagination: {
      //   async handler () {
      //     console.debug('pagination watcher')
      //     this.getProjectDetailPhaseTask()
      //   }
      // },
      search () {
        console.debug('search watcher')
        this.debouncedGetData()
      },
      searchCompany () {
         if (this.searchCompany && this.searchCompany.length >= 3) {
          this.debouncedGetCompanies()
        }
      }
    },
    created () {
      this.getUserLoginsMap()
      let today = new Date()
      this.searchBy.endDate = today.toISOString().split('T')[0]
      let oToday = new Date()
      oToday.setMonth(oToday.getMonth() - 2)
      this.searchBy.startDate = oToday.toISOString().split('T')[0]

      this.debouncedGetData = _.debounce(this.getProjectDetailPhaseTask, 500)
    },
    methods: {
      showProgressBar () {
        this.loadingBar = true
      },
      hideProgressBar () {
        this.loadingBar = false
      },
      async fetchData () {
        const response = this.DataList
        return response
      },
      async getUserLoginsMap () {
        try {
          let response = await this.$http.get(`/api/userlogin/all`)
          let userLogins = response.data
          this.userLoginMap = userLogins.reduce(function (map, obj) {
            map[obj.username] = obj.employee.firstName
            return map
          }, {})
        } catch (error) {
          console.log(error)
        }
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      // TODO not a server pagination, can be improve
      async getProjectDetailPhaseTask () {
        try {
          this.showProgressBar()
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search || ''
          let pageNoXHR = page - 1
          let tempDay = new Date()
          let defaultEndDt = tempDay.setDate(tempDay.getDate() - 5)
          let endDt = this.searchBy.startDate == '' ? defaultEndDt : this.searchBy.endDate
          let startDt = this.searchBy.endDate == '' ? new Date() : this.searchBy.startDate
          console.log(this.searchBy.isDone)
          let isDone = this.searchBy.isDone.length == 0 ? '' : (this.searchBy.isDone.includes('Yes') ? true : false)
          let response = await this.$http.get(`/api/report/project/alltaskdetail?so=${sortBy || 'startDate'}&dc=${descending || false}&sdt=${startDt}&edt=${endDt}&isd=${isDone}`)

          this.hideProgressBar()
          this.DataList = response.data
          this.totalRows = response.data.length
        } catch (error) {
          console.log(error)
        }
      },
      async getCustomers () {
        try {
          let response = await this.$http.get(`/api/customer/select?companyId=${this.editedItem.customer.company.id}`)
          this.customers = response.data
          let custobj = _.find(this.customers, ['id', this.editedItem.customer.id])
          this.editedItem.customerSelect = custobj || ''
          this.showCustomerSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getCompaniesPaging () { // paging not yet implemented
        try {
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchCompany == null ? '' : this.searchCompany
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/company/autocomplete?ps=100&pn=0&so=name&q=${q}`)

          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCompanies () {
        try {
          let response = await this.$http.get('/api/company/select')
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },

      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (text) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = text || 'Cancelled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      resetInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      }
    }

  }
</script>
<style>
  #projectvisitlist thead tr {
    background-color: antiquewhite;
  }

  #projectvisitlist table.v-table thead tr th {
    font-size: 1.025em;
  }
</style>
